// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationLayout_container__3SEuL","content":"NavigationLayout_content__2nD86","footer":"NavigationLayout_footer__2K4Kj","spinner":"NavigationLayout_spinner__3rM6L"};